import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import { useMediaQuery, useTheme, TextField, Button, Checkbox, Container, Dialog, DialogTitle, DialogContent, DialogActions, FormControlLabel, InputLabel, Select, MenuItem, Typography, Grid, Box, RadioGroup, Radio, createTheme } from '@mui/material';
import Error from '../Error/Error';
import Success from '../Success/Success';
import { getUsername } from '../../context/AuthFunc';
import { useTranslation } from 'react-i18next';
import { getOrgranizationalUnits, postRequest, addEmployee } from '../../api/axios';
import "./newEmployee.css";
import Employees from '../List/Employees';

const NewEmployee = () => {
    const { t } = useTranslation('global');

    const theme = createTheme({
        breakpoints: {
            values: {
            xs: 0,
            sm: 600,
            md: 900,
            lg: 1200,
            xl: 1536,
            xxl: 1650
            },
        },
    })
    const isSmall = useMediaQuery(theme.breakpoints.down("md"));

    const [cardNo, setCardNo] = useState('');
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [JMBG, setJMBG] = useState('');
    const [active, setActive] = useState(false);
    const [sector, setSector] = useState('');
    const [organizationalUnit, setOrganizationalUnit] = useState('');
    const [workplace, setWorkplace] = useState('');
    const [section, setSection] = useState('');
    const [cardLimitType, setCardLimitType] = useState();
    const [limit, setLimit] = useState();
    const [dailyLimit, setDailyLimit] = useState();
    const [remainingCredit, setRemainingCredit] = useState();
    const [isHoliday, setIsHoliday] = useState(false);
    const [holiday, setHoliday] = useState('');
    const [holidayDate, setHolidayDate] = useState('');
    const [note, setNote] = useState('');
    const [image, setImage] = useState(null);
    const [imageBase64, setImageBase64] = useState('');

    const [orgUnits, setOrgUnits] = useState([]);

    const [errMsg, setErrMsg] = useState('');
    const [succ, setSucc] = useState('');
    const [refreshKey, setRefreshKey] = useState(0);

    const fetchOrganzizationUnits = async() =>{
            const res = await getOrgranizationalUnits();
            setOrgUnits(res);
        }
    
    useEffect(()=>{
        
        fetchOrganzizationUnits();
    },)

    const handleSubmit = async (event) => {
        event.preventDefault();
        if(!firstName){
            setErrMsg(t("newEmployee.firstNameRequired"));
            return;
        }
        if(!lastName){
            setErrMsg(t("newEmployee.lastNameRequired"));
            return;            
        }
        if(!JMBG){
            setErrMsg(t("newEmployee.JMBGRequired"));
            return;
        }
        const newEmployee = {
            serial_num: cardNo,
            name: firstName,
            last_name: lastName,
            jmbg: JMBG,
            active: active ? 1 : 0,
            sector,
            organization_unit_id: parseInt(organizationalUnit),
            workplace,
            section,
            limit_type: parseInt(cardLimitType),
            daily_limit: parseFloat(dailyLimit) || 0,
            monthly_limit_id: parseInt(limit) || 0,
            credit: parseFloat(remainingCredit) || 0,
            holiday_name: holiday,
            holiday_date: holidayDate,
            note,
            photo: imageBase64
        };
        try{
            const response = await addEmployee(newEmployee);
            if(!response.success){
                setErrMsg(t("newTicket.somethingWentWrong"));
                setTimeout(() => setErrMsg(''), 3000);
            }
            else{
                
                setSucc(t("newTicket.successfullyAdded"));
                setCardNo('');
                setFirstName('');
                setLastName('');
                setJMBG('');
                setActive(false);
                setSector('');
                setOrganizationalUnit('');
                setWorkplace('');
                setSection('');
                setCardLimitType('');
                setLimit('');
                setDailyLimit('');
                setRemainingCredit('');
                setIsHoliday(false);
                setHoliday('');
                setHolidayDate('');
                setNote('');
                setImage(null);
                setImageBase64("");
                setTimeout(() => setSucc(''), 3000);
                setRefreshKey(prev => prev + 1);
            }
        }
        catch (error) {
            setErrMsg(t("newTicket.failedToAddTicket"));
        }
    };

    const handleActiveChange = (e) => {
        setActive(!active);
    };

    return (
    <Container maxWidth="lg" className="container-employee" sx={{ p: 3, flexShrink: 0 , mt: 4, zoom: {md:0.8, lg: 0.9, xl: 0.9}, '@media (min-width:1650px)': {zoom: 1.2,}}} >
        <Typography variant="h4" sx={{ mb:4 }}>{t("newEmployee.newEmployee")}</Typography>
        <form onSubmit={handleSubmit} style={{ width:"90%", display:"flex", justifyContent:"center", alignItems:"center"}}>
        {isSmall ? (
            <Grid container direction="column" spacing={2}>
                <Grid container spacing={2}>
                    <Grid item xs={6}>
                        <input
                            accept="image/*"
                            style={{ display: 'none' }}
                            id="employee-image-upload-mobile"
                            type="file"
                                onChange={(e) => {
                                    const file = e.target.files[0];
                                    if (file) {
                                        const reader = new FileReader();
                                        reader.onload = (event) => {
                                            setImageBase64(event.target.result);
                                            setImage(file);
                                        };
                                        reader.readAsDataURL(file);
                                    }
                                }}
                        />
                        <label htmlFor="employee-image-upload-mobile">
                            {image ? (
                                <Box
                                    component="img"
                                    src={URL.createObjectURL(image)}
                                    sx={{
                                        width: "100%",
                                        maxHeight: "200px",
                                        objectFit: "contain",
                                        boxShadow: 1,
                                        cursor: 'pointer'
                                    }}
                                    alt="Uploaded image"
                                />
                            ) : (
                                <Box
                                    sx={{
                                        width: "140px",
                                        height: "200px",
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        border: '1px solid gray',
                                        boxShadow: 1,
                                        cursor: 'pointer',
                                        backgroundColor: '#f5f5f5'
                                    }}
                                >
                                    <Typography fontSize="small">Upload</Typography>
                                </Box>
                            )}
                        </label>
                    </Grid>

  <Grid item xs={6}>
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <TextField
          label={t("newEmployee.firstName")}
          fullWidth
          value={firstName}
          onChange={(e) => setFirstName(e.target.value)}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          label={t("newEmployee.lastName")}
          fullWidth
          value={lastName}
          onChange={(e) => setLastName(e.target.value)}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          label={t("newEmployee.JMBG")}
          fullWidth
          value={JMBG}
          onChange={(e) => setJMBG(e.target.value)}
        />
      </Grid>
    </Grid>
  </Grid>
</Grid>

                <Grid item>
                    <FormControlLabel
                    label={t("newEmployee.active")}
                    control={
                        <Checkbox
                        checked={active}
                        onChange={handleActiveChange}
                        value={active}
                        />
                    }
                    />
                </Grid>
                <Grid item>
                    <TextField
                    label={t("newEmployee.sector")}
                    fullWidth
                    value={sector}
                    onChange={(e) => setSector(e.target.value)}
                    />
                </Grid>
                <Grid item>
                    <Select
                    fullWidth
                    value={organizationalUnit}
                    onChange={(e) => setOrganizationalUnit(e.target.value)}
                    displayEmpty
                    >
                    <MenuItem value="" disabled>
                        {t("newEmployee.selectOrganizationalUnit")}
                    </MenuItem>
                    {orgUnits.map((orgUnit) => (
                        <MenuItem key={orgUnit.id} value={orgUnit.id}>
                        {orgUnit.name}
                        </MenuItem>
                    ))}
                    </Select>
                </Grid>
                <Grid item>
                    <TextField
                    label={t("newEmployee.workplace")}
                    fullWidth
                    value={workplace}
                    onChange={(e) => setWorkplace(e.target.value)}
                    />
                </Grid>
                <Grid item>
                    <TextField
                    label={t("newEmployee.section")}
                    fullWidth
                    value={section}
                    onChange={(e) => setSection(e.target.value)}
                    />
                </Grid>
                <Grid item>
                    <RadioGroup
                    value={cardLimitType}
                    onChange={(e) => setCardLimitType(e.target.value)}
                    >
                    <FormControlLabel
                        value="1"
                        control={<Radio />}
                        label={t("newEmployee.basicCard")}
                    />
                    <FormControlLabel
                        value="2"
                        control={<Radio />}
                        label={t("newEmployee.monthLimitedCard")}
                    />
                    <FormControlLabel
                        value="3"
                        control={<Radio />}
                        label={t("newEmployee.unlimitedCard")}
                    />
                    </RadioGroup>
                </Grid>
                <Grid item>
                    <TextField
                    label={t("newEmployee.limit")}
                    fullWidth
                    value={limit}
                    onChange={(e) => setLimit(e.target.value)}
                    />
                </Grid>
                <Grid item>
                    <TextField
                    label={t("newEmployee.dailyLimit")}
                    fullWidth
                    value={dailyLimit}
                    onChange={(e) => setDailyLimit(e.target.value)}
                    />
                </Grid>
                <Grid item>
                    <TextField
                    label={t("newEmployee.remainingCredit")}
                    fullWidth
                    value={remainingCredit}
                    onChange={(e) => setRemainingCredit(e.target.value)}
                    disabled
                    />
                </Grid>
                <Grid item>
                    <FormControlLabel
                    control={
                        <Checkbox
                        checked={isHoliday}
                        onChange={(e) => setIsHoliday(e.target.checked)}
                        value={t("newEmployee.isHoliday")}
                        />
                    }
                    label={t("newEmployee.isHoliday")}
                    />
                </Grid>
                {isHoliday && (
                    <>
                    <Grid item>
                        <TextField
                        label={t("newEmployee.holiday")}
                        fullWidth
                        value={holiday}
                        onChange={(e) => setHoliday(e.target.value)}
                        />
                    </Grid>
                    <Grid item>
                        <TextField
                        type="date"
                        fullWidth
                        label={t("newEmployee.holidayDate")}
                        value={holidayDate}
                        onChange={(e) => setHolidayDate(e.target.value)}
                        />
                    </Grid>
                    </>
                )}
                <Grid item>
                    <TextField
                    label={t("newEmployee.note")}
                    fullWidth
                    value={note}
                    onChange={(e) => setNote(e.target.value)}
                    />
                </Grid>
                <Grid item>
                    <TextField
                    label={t("newEmployee.cardNo")}
                    fullWidth
                    value={cardNo}
                    onChange={(e) => setCardNo(e.target.value)}
                    required
                    title={t("newEmployee.cardNo")}
                    />
                </Grid>
                <Grid item sx={{ display: "flex", justifyContent: "flex-end" }}>
                    <Button sx={{ width: "50%" }} variant="contained" type="submit">
                    {t("newTicket.add")}
                    </Button>
                </Grid>
                </Grid>

        ) : (
        <>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Grid container direction="row" alignItems="center" spacing={2}>
                        <Grid item xs={8}>
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <TextField
                                        label={t("newEmployee.firstName")}
                                        fullWidth
                                        value={firstName}
                                        onChange={(e) => setFirstName(e.target.value)}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        label={t("newEmployee.lastName")}
                                        fullWidth
                                        value={lastName}
                                        onChange={(e) => setLastName(e.target.value)}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        label={t("newEmployee.JMBG")}
                                        fullWidth
                                        value={JMBG}
                                        onChange={(e) => setJMBG(e.target.value)}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={4} sx={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
                            <input
                                accept="image/*"
                                style={{ display: 'none' }}
                                id="employee-image-upload"
                                type="file"
                                onChange={(e) => {
                                    const file = e.target.files[0];
                                    if (file) {
                                        const reader = new FileReader();
                                        reader.onload = (event) => {
                                            setImageBase64(event.target.result);
                                            setImage(file);
                                        };
                                        reader.readAsDataURL(file);
                                    }
                                }}
                            />
                            <label htmlFor="employee-image-upload">
                                {image ? (
                                    <Box
                                        component="img"
                                        src={URL.createObjectURL(image)}
                                        sx={{
                                            maxWidth: "100%",
                                            maxHeight: "300px",
                                            objectFit: "contain",
                                            boxShadow: 1,
                                            mb: 2,
                                            cursor: 'pointer'
                                        }}
                                        alt="Uploaded image"
                                    />
                                ) : (
                                    <Box
                                        sx={{
                                            width: "140px",
                                            height: "200px",
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            border: '1px solid gray',
                                            boxShadow: 1,
                                            mb: 2,
                                            cursor: 'pointer',
                                            backgroundColor: '#f5f5f5'
                                        }}
                                    >
                                        <Typography>Upload image</Typography>
                                    </Box>
                                )}
                            </label>
                            <FormControlLabel
                                label={t("newEmployee.active")}
                                control={
                                    <Checkbox
                                        checked={active}
                                        onChange={handleActiveChange}
                                        value={active}
                                    />
                                }
                            />
                        </Grid>
                    </Grid>
                </Grid>
                {/*Sektori*/}
                <Grid item xs={12} sm={12}>
                    <TextField
                        label={t("newEmployee.sector")}
                        fullWidth
                        value={sector}
                        onChange={(e) => setSector(e.target.value)}
                    />
                </Grid>
                {/*Organizacione jedinice*/}
                <Grid item xs={12} sm={12}>
                    <Select
                        fullWidth
                        value={organizationalUnit} // Koristi sektor kao vrednost
                        onChange={(e) => setOrganizationalUnit(e.target.value)} // Postavi samo ID selektovanog sketora
                        displayEmpty
                    >
                        <MenuItem value="" disabled>
                        {t("newEmployee.selectOrganizationalUnit")}
                        </MenuItem>
                        {orgUnits.map((orgUnit) => (
                        <MenuItem key={orgUnit.id} value={orgUnit.id}>
                            {orgUnit.name}
                        </MenuItem>
                        ))}
                    </Select>
                </Grid>
                {/*Radno mesto*/}
                <Grid item xs={12} sm={12}>
                    <TextField
                        label={t("newEmployee.workplace")}
                        fullWidth
                        value={workplace}
                        onChange={(e) => setWorkplace(e.target.value)}
                    />
                </Grid>
                {/*Pogon*/}
                <Grid item xs={12} sm={12}>
                    <TextField
                        label={t("newEmployee.section")}
                        fullWidth
                        value={section}
                        onChange={(e) => setSection(e.target.value)}
                    />
                </Grid>
            </Grid>
            <Grid container spacing={2}>
                <Grid item xs={6} sx={{padding: "1"}}>
                                <RadioGroup value={cardLimitType} onChange={(e) => setCardLimitType(e.target.value)}>
                                    <FormControlLabel value="1" control={<Radio />} label={t("newEmployee.basicCard")} />
                                    <FormControlLabel value="2" control={<Radio />} label={t("newEmployee.monthLimitedCard")} />
                                    <FormControlLabel value="3" control={<Radio />} label={t("newEmployee.unlimitedCard")} />
                                </RadioGroup>
                            </Grid>
                <Grid item xs={6}>
                        <Grid container spacing={1}>
                                <Grid item xs={12}>
                                    <TextField
                                        label={t("newEmployee.limit")}
                                        fullWidth
                                        value={limit}
                                        onChange={(e) => setLimit(e.target.value)}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        label={t("newEmployee.dailyLimit")}
                                        fullWidth
                                        value={dailyLimit}
                                        onChange={(e) => setDailyLimit(e.target.value)}
                                     />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        label={t("newEmployee.remainingCredit")}
                                        fullWidth
                                        value={remainingCredit}
                                        onChange={(e) => setRemainingCredit(e.target.value)}
                                        disabled
                                     />
                                </Grid>
                        </Grid>
                </Grid>
                <Grid item xs={12}>
                    <FormControlLabel
                            control={
                            <Checkbox
                                checked={isHoliday}
                                onChange={(e) => setIsHoliday(e.target.checked)}
                                value={t("newEmployee.isHoliday")}
                            />
                        }
                        label={t("newEmployee.isHoliday")}
                    />
                </Grid>
                {isHoliday &&
                <><Grid item xs={6}>
                        <TextField
                            label={t("newEmployee.holiday")}
                            fullWidth
                            value={holiday}
                            onChange={(e) => setHoliday(e.target.value)}
                        />
                </Grid>
                <Grid item xs={6}>
                    <TextField
                        type="date"
                        fullWidth
                        label={t("newEmployee.holidayDate")}
                        value={holidayDate}
                        onChange={(e) => setHolidayDate(e.target.value)}
                    />
                </Grid></>}
                <Grid item xs={12} sm={12}>
                    <TextField
                        label={t("newEmployee.note")}
                        fullWidth
                        value={note}
                        onChange={(e) => setNote(e.target.value)}
                    />
                </Grid>
                <Grid item xs={12} sm={12}>
                    <TextField
                        label={t("newEmployee.cardNo")}
                        fullWidth
                        value={cardNo}
                        onChange={(e) => setCardNo(e.target.value)}
                        required
                        title={t("newEmployee.cardNo")}
                    />
                </Grid>
            
                <Grid item xs={12} sx={{ width:"100%", display:"flex", justifyContent:"flex-end"}}>
                    <Button sx={{ width:"50%" }} variant="contained" type="submit">{t("newTicket.add")}</Button>
                </Grid>
            </Grid>
        </>    
        )}
        
    </form>

    {errMsg && <Error message={errMsg} onClose={() => setErrMsg('')} />}
    {succ && <Success message={succ} onClose={() => setSucc('')} />}
        
              <Employees key={refreshKey}/>
    </Container>
    );
};

export default NewEmployee;
